<template>
  <LayoutDivasChadsMinimal>
    <div id="sing-up">
      <section class="main">
        <div class="container">

          <div class="register">
            <div class="register-box">
              <h1>{{ $t('register.creator.title') }}</h1>
              <span v-html="$t('register.creator.message')"></span>
              <div>
                <button @click="goToWebstars">{{ $t('register.creator.button') }}</button>
              </div>
            </div>

            <div class="register-box">
              <h1>{{ $t('register.user.title') }}</h1>
              <span v-html="$t('register.user.message')"></span>
              <div>
                <button @click="goToUserRegister" class="">{{ $t('register.user.button') }}</button>
              </div>
            </div>
          </div>

          <div class="support-box">
            <router-link :to="{ name: 'support' }">{{ $t('zammad_support.link') }}</router-link>
          </div>

        </div>
      </section>
    </div>
    <template slot="after">
      <Footer />
    </template>
  </LayoutDivasChadsMinimal>
</template>

<script>
import Footer from "../../components/Footer";
import LayoutDivasChadsMinimal from "../../layouts/LayoutDivasChadsMinimal";
import ThemeManager from "../../modules/ThemeManager/ThemeManager.js";

import resources from "../../resources";

export default {
  components: {
    LayoutDivasChadsMinimal,
    Footer,
  },
  data() {
    return {
      token: "",
      newUserData: {
        data: {
          email: null,
          finish_token: null,
        },
        loading: false,
        error: false,
      },
      WEBSTARPANEL_REGISTER_URL: resources.webstars.RegisterUrl()
    };
  },
  methods: {
    successfullRegisterHandler() {
      if (this.$auth.user().membership_active) {
        this.$router.replace({ name: "home" });
      } else {
        this.$router.replace({ name: "dashboard" });
      }
    },
    failedRegisterHandler(resp) {
      //this.$router.replace({name: 'login'});
    },
    goToLogin() {
      this.$router.push({ name: "login" });
    },
    goToWebstars() {
      // Open new tab with webstars registration
      window.open(this.WEBSTARPANEL_REGISTER_URL, "_blank");
    },
    goToUserRegister() {
      this.$router.push({ name: "signup.user" });
    },
  },
  mounted() {
    this.token = this.$route.query.token;

    // this.$refs.webstarRegisterMessage.innerHTML = this.$t(
    //   "register.webstar.message"
    // );
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/variables";
@import "../../styles/classes";

.container {
  display: flex;
  padding-block: 2em;
  background-color: var(--background_01);
  flex-direction: column;

  .register {
    display: flex;
    // flex-direction: row;

    // @media (max-width: 768px) {
      flex-direction: column;
    // }

    .register-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-inline: 1em;

      // @media (max-width: 768px) {
        margin-top: 1.5em;
      // }

      h1 {
        font-size: 2em;
        font-weight: bold;
        margin: 0;
        line-height: 1;
        text-wrap: balance;
        width: 100%;
      }

      span {
        font-size: 1.2em;
        margin: 0.5em 0;
        width: 100%;
      }

      div {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: auto;
        padding-top: 1em;
        width: 100%;

        button {
          @extend %fresh-btn;
          padding-block: 0.75em;
          width: 100%;

          @media (min-width: 769px) {
            width: 50%;        
          }
        }
      }
    }
  }

  .support-box {
    display: flex;
    justify-content: center;
    padding-block: 1em;
    margin-top: 1em;

    a {
      color: var(--pallete_clear_text_color);
      text-decoration: none;
    }
  }

}
</style>
